import { hiringManagerMentorJobsConstants } from "../../_constants";

const initialState = {};

//all mentors applied reducer
export const get_all_mentors_applied_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerMentorJobsConstants.GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerMentorJobsConstants.GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allMentorsAppliedData: action.payload,
        // data: action.payload
      };
    case hiringManagerMentorJobsConstants.GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//all mentors applied reducer
export const get_accept_reject_mentor_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerMentorJobsConstants.GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerMentorJobsConstants.GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS:
    case hiringManagerMentorJobsConstants.ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        mentorApplicationData: action.payload,
        // data: action.payload
      };
    case hiringManagerMentorJobsConstants.GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE:
    case hiringManagerMentorJobsConstants.ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

//all mentors applied reducer
export const get_suggested_mentors_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerMentorJobsConstants.GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerMentorJobsConstants.GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        suggestedMentorsData: action.payload,
        // data: action.payload
      };
    case hiringManagerMentorJobsConstants.GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

//all mentors applied reducer
export const view_mentor_public_profile_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerMentorJobsConstants.VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerMentorJobsConstants.VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        mentorPublicProfileData: action.payload,
        // data: action.payload
      };
    case hiringManagerMentorJobsConstants.VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};


//all applied mentors reducer
export const get_all_applied_mentor_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerMentorJobsConstants.GET_ALL_APPLIED_MENTOR_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerMentorJobsConstants.GET_ALL_APPLIED_MENTOR_ACTION_SUCCESS:
      return {
        type: "alert-success",
        appliedMentorsData: action.payload,
      };
    case hiringManagerMentorJobsConstants.GET_ALL_APPLIED_MENTOR_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
